require('./cancelCardPayLaterView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ components
const CancelPayLater = require('components/contactCenter/cancelCardPayLater/cancelCardPayLater');
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const CancelCardPayLaterErrorStep = require('components/contactCenter/cancelCardPayLater/cancelCardPayLaterErrorStep');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @ core
const { formatText } = require('core/i18n').i18n;

// @ utilities
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @ actions
const cancelCardPayLaterActions = require('actions/cancelCardPayLater');


class CancelCardPayLaterView extends React.Component {

    constructor(props) {
        super(props);
        const { match: { params: { cardId } } } = props;
        this.state = {
            redirectUrl: `/myprofile/cards/${cardId}/cancel-pay-later-confirm`
        }
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.routeToWizard = this.routeToWizard.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentWillMount() {
        this.props.reset();
    }

    handleConfirmLeave() {
        this.props.reset();
        const { history, match: { params: { cardId } } } = this.props;
        history.push(`/myprofile/cards/${cardId}/movements`);
    }

    isReady() {
        return false;
    }

    routeToWizard() {
        this.props.history.push(this.state.redirectUrl);
    }

    buildContent() {
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);

        const payLaterClassName = contactCenterClassName('col-xs-8', 'cancel-pay-later-view__cancel-pay-later-column');
        const detalisClassName = contactCenterClassName('col-xs-4', 'cancel-pay-later-view__card-details-column');

        return (
            <section className="cancel-pay-later-view__content">
                <div className={payLaterClassName}>
                    <CancelPayLater
                        immCard={immCard}
                        cardId={this.props.match.params}
                        immCancelCardPayLater={this.props.immCancelCardPayLater}
                        routeToWizard={this.routeToWizard}
                    />
                </div>
                <div className={detalisClassName}>
                    <CardDetailsSideBar immCard={immCard} />
                </div>
            </section>
        );
    }

    buildFailureView() {
        return (
            <div className="row no-gutter">
                <div className="col-xs col-xs-12">
                    <CancelCardPayLaterErrorStep />
                </div>
            </div>
        );
    }

    render() {
        const { immCancelCardPayLater } = this.props;
        const content = immCancelCardPayLater.get('errorReceived') ? this.buildFailureView() : this.buildContent();
        const pageTitle = formatText('accountModifyStep-pageTitle');
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const confirmationMessage = formatText('preleaveCancelModal-confirmationMessagePreleave');
        const confirmationTitle = formatText('preleaveCancelModal-confirmationTitleMessagePreleave');
        const acceptText = formatText('preleaveCancelModal-cancelButton');
        const cancelText = formatText('preleaveCancelModal-stayHereButton');
        const mappingBreadcrumb = [
            {
                text: formatText('accountModifyStep-pageTitle'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardMoreOptions-payLater'),
                url: ''
            }
        ]
        return (
            <section className="cancel-pay-later-view">
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    isReady={this.isReady}
                    cancelText={cancelText}
                    beforeLeaving={this.beforeLeaving}
                    onConfirmLeave={this.handleConfirmLeave}
                    allowRedirectTo={this.state.redirectUrl}
                />
                <OKHeaderCC
                    title={pageTitle}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="cancel-pay-later-view__body">
                    {content}
                </div>
            </section>
        );
    }
}


CancelCardPayLaterView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCancelCardPayLater: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func
}

module.exports.constructor = CancelCardPayLaterView;
module.exports.CancelCardPayLaterView = connect(state => ({
    immCards: state.cards,
    immCancelCardPayLater: state.cancelCardPayLater,
}), {
    reset: cancelCardPayLaterActions.reset
})(withRouter(CancelCardPayLaterView));
